import React from 'react';

interface EmptySlashCircleIconProps {
  className?: string;
}

/** Figma empty-state slash-circle (64×64). Color via `className` (e.g. text-primary). */
export const EmptySlashCircleIcon: React.FC<EmptySlashCircleIconProps> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    className={className}
    aria-hidden
  >
    <path
      d="M13.1466 13.1467L50.8533 50.8534M50.8531 13.1467L13.1465 50.8534M58.6666 32C58.6666 46.7276 46.7276 58.6667 32 58.6667C17.2724 58.6667 5.33331 46.7276 5.33331 32C5.33331 17.2724 17.2724 5.33337 32 5.33337C46.7276 5.33337 58.6666 17.2724 58.6666 32Z"
      stroke="currentColor"
      strokeWidth="2.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
